import React, { Fragment, useState } from 'react';
import api from '../../../../api';
import { DateFormats, formatDate, ILeadActivity } from '../../../../core';
import { useLeadActivities } from '../../../../core/hooks/useLeadActivities';
import { activityTypeToIconMapper } from './add-activity';

interface IChangeLogItemProps {
  activity: ILeadActivity;
}

export const ChangeLogItem: React.FunctionComponent<IChangeLogItemProps> = (
  props
) => {
  const p = props.activity;
  const { getActivityIcon } = useLeadActivities(api.lead);
  return (
    <Fragment>
      <li className="d-flex mb-3 position-relative zIndex-1">
        <div className="activity-icon rounded-circle bg-white shadow d-flex align-items-center justify-content-center mr-2 mt-2">
          <i className={getActivityIcon(p.type) + ' text-gray-500'}></i>
        </div>
        <div className="activity-box arrow border bg-white rounded p-2 col">
          <div className="d-flex align-items-center mb-2 p-1">
            <span className="font-sm font-weight-semibold">{p.title}</span>
          </div>
          <div className="row font-xs gutter-5 px-1 pb-1 pt-0 align-items-center">
            <div className="col-auto text-gray-500">
              {formatDate(p.updatedAt, DateFormats.NormalDateFormat)} at{' '}
              {formatDate(p.updatedAt, DateFormats.TimeOnlyFormat)}
            </div>
          </div>
        </div>
      </li>
    </Fragment>
  );
};
